import {saleService} from "../services/SaleService";
import { paymentsStatusesService } from "@/modules/payments/services";
import _ from 'lodash'

const state = {
  sale: null,
  paymentStatus: null,
}

const getters = {
  sale: (state) => state.sale,
  paymentStatus: (state) => state.paymentStatus,
}

const mutations = {
  setSale(state, sale) {
    state.sale = sale;
  },
  setPaymentStatus(state, paymentStatus) {
    state.paymentStatus = paymentStatus;
  },
}

const actions = {
  async fetchSale({ commit }, {payload}) {
    const {saleUid} = payload
    try {
      const res = await saleService.get(saleUid)
      commit('setSale', res.data.cart)
      return res.data
    } catch (e) {
      console.error('error', e);
    }
  },
  async fetchPaymentStatus({ commit }, {payload}) {
    const {paymentStatusUid} = payload
    try {
      const res = await paymentsStatusesService.get(paymentStatusUid)
      commit('setPaymentStatus', res.data)
      return res.data
    } catch(e) {
      console.error('error', error);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
